module.exports = __webpack_public_path__ + "img/bier.cea121f0.jpg";